// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Registration from './pages/Registration';
import Login from './pages/Login';
import PortfolioPage from './pages/Portfolio';
import SearchPage from './pages/SearchPage';
import Search from './pages/Search';
import PredictionPage from './pages/PredictionPage';
import PortfolioDashboard from './components/PortfolioDashboard'; 
import TigerTradeDashboard from './pages/TigerTradeDashboard';
import TickerDashboard from './pages/TickerDashboard';
import Stocks from './pages/StockScanner';
import Rms from './pages/Rms'
import PortfolioOverview from './components/PortfolioOverview';
import OrderForm from './components/OrderForm';
// import OrderHistory from './components/OrderHistory';
import './App.css';


function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/registration" />;
}

// Main App component
function AppContent() {
  return (
    <div className="App">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />+
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/portfolio" 
            element={
              <ProtectedRoute>
                <PortfolioPage />
                {/* <PortfolioOverview /> */}
              </ProtectedRoute>
            } 
          />     
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                {/* <Dashboard /> */}
                <PortfolioDashboard />
              </ProtectedRoute>
            } 
          />             
          <Route 
            path="/prediction/:symbol" 
            element={
              <ProtectedRoute>
                <PredictionPage />
              </ProtectedRoute>
            } 
          />             
          <Route 
            path="/search" 
            element={
              <ProtectedRoute>
                <Search />
                {/* <SearchPage /> */}
              </ProtectedRoute>
            } 
          />   
          <Route path="/stocks" element={
               <ProtectedRoute>
                 <Stocks />
               </ProtectedRoute>
           } />
            <Route path="/risk" element={
               <ProtectedRoute>
                 <Rms />
               </ProtectedRoute>
           } />           
          <Route 
            path="/tradeOperation" 
            element={
              <ProtectedRoute>
                {/* <TigerTradeDashboard /> */}
                {/* <OrderHistory /> */}
                <OrderForm />
              </ProtectedRoute>
            } 
          />            
          <Route 
              path="/stockAnalysis/:symbol" 
              element={
                  <ProtectedRoute>
                      <TickerDashboard />
                  </ProtectedRoute>
              } 
          />                
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

// Wrap everything with providers
function App() {
  return (
    <React.StrictMode>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </React.StrictMode>
  );
}

export default App;